<template>
  <div class="products">
    <div v-if="products.length > 0">
      <div class="products__header">
        <p>Produtos em destaque</p>
      </div>
      <div class="carousel-container">
        <div ref="glideContainer" class="products__carousel glide">
          <div class="glide__track" data-glide-el="track">
            <div class="glide__slides">
              <li v-for="(product, index) in products" :key="index">
                <product-card :product="product"></product-card>
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="featuredBanner.image" class="products__featured">
      <a
        v-if="featuredBanner.url"
        :href="featuredBanner.url"
        :target="featuredBanner.new_window ? '_blank' : '_self'"
      >
        <img :src="featuredBanner.image" alt="Imagem do Destaque" />
      </a>
      <img v-else :src="featuredBanner.image" alt="Imagem do Destaque" />
    </div>
  </div>
</template>

<script>
import FeaturedBannerService from '@/services/featured-banner.service';
import StoreHighlightService from '@/services/store-highlight.service';
import ProductCard from '@/components/Product/ProductCard.vue';
import Glide from '@glidejs/glide';

export default {
  name: 'products-featured',
  components: {
    ProductCard,
  },
  data: () => {
    return {
      products: [],
      featuredBanner: {},
      glide: null,
      isLoading: true,
    };
  },
  methods: {
    load() {
      this.isLoading = true;

      Promise.all([
        FeaturedBannerService.getRandom(),
        StoreHighlightService.get(),
      ])
        .then(([bannerResponse, productsResponse]) => {
          const { data: products } = productsResponse.data;
          const { data: banner } = bannerResponse;

          this.products = products;
          this.featuredBanner = banner;
          this.$nextTick(() => this.initCarousel());
        })
        .finally(() => (this.isLoading = false));
    },
    initCarousel() {
      this.glide = new Glide(this.$refs.glideContainer, {
        autoplay: this.products.length > 4 ? 3000 : false,
        perView: Math.min(this.products.length, 4),
        bound: true,
        breakpoints: {
          1600: {
            perView: Math.min(this.products.length, 3),
          },
          992: {
            perView: 1,
          }
        },
      }).mount();
    },
  },
  beforeMount() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.carousel-container {
  margin: 0 15vw;
}

.products {
  background: linear-gradient(0.48deg, #eaedf5 19.66%, transparent 91.72%);
  padding-bottom: 32px;

  &__header {
    p {
      text-align: center;
      color: var(--color-secondary);
      font-weight: bold;
      font-size: 1.8em;
    }
  }

  &__carousel {
    margin-top: 48px;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .product-card {
      /* margin: 0 16px; */
    }
  }

  &__featured {
    margin-top: 64px;
    text-align: center;

    img {
      width: 1170px;
      height: 140px;
      object-fit: fill;
      border-radius: 12px;
      margin: auto;
    }
  }
}

@media(max-width: 992px) {
  .products {

    &__featured {

      img {
        width: 100%;
        height: auto;
        border-radius: 0;
      }
    }
  }
}
</style>
